/** Grid en pantalla pequeña; fila horizontal desde xl (junto al sidebar fijo). */
export const DOC_ITEM_ROW =
  'grid w-full min-w-0 grid-cols-2 gap-x-2 gap-y-3 sm:grid-cols-4 xl:flex xl:flex-nowrap xl:items-start xl:gap-1.5';

export const DIC = {
  product: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5.5rem]',
  service: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5.5rem]',
  description: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[4.5rem]',
  unit: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-20',
  project: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[4.5rem]',
  qty: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-16',
  price: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-24',
  igv: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-16',
  subtotal: 'w-full min-w-0 col-span-2 sm:col-span-1 xl:col-span-auto xl:w-[7rem]',
  intake: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-[5rem]',
  actions: 'w-full min-w-0 col-span-1 xl:col-span-auto xl:w-8',
  activoInfo: 'w-full min-w-0 col-span-2 sm:col-span-2 xl:col-span-auto xl:flex-1 xl:min-w-0',
};
